import { TreasuryTransferFilterEnum } from '@up/data';
import { IsNumber, IsOptional, IsString } from 'class-validator';

export class TreasuryFullModuleSummaryRequestDto {
  @IsNumber()
  businessEntityId: number;

  @IsNumber()
  @IsOptional()
  merchantId: number;

  @IsNumber()
  @IsOptional()
  costCentreId: number;

  @IsString()
  @IsOptional()
  fromDate?: Date | string;

  @IsString()
  @IsOptional()
  toDate?: Date | string;

  @IsString()
  @IsOptional()
  sourceId?: number;

  @IsString()
  @IsOptional()
  transferFilter?: TreasuryTransferFilterEnum | undefined;

  @IsString()
  @IsOptional()
  description?: string;
}
